/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Connection_New_Key_DescriptionInputs */



/**
* | output |
* | --- |
* | "The new key is checked first and then applies to every model of this connection." |
*
* @param {Private_Models_Connection_New_Key_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_connection_new_key_description = /** @type {((inputs?: Private_Models_Connection_New_Key_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Connection_New_Key_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der neue Schlüssel wird zuerst geprüft und gilt dann für alle Modelle dieser Verbindung.")
	return /** @type {LocalizedString} */ ("The new key is checked first and then applies to every model of this connection.")
});